import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OutletComponent } from './outlet.component';

import { DossierListComponent, DossierEditComponent, DossierResolver } from '../dossier';
import { RecordListComponent, RecordEditComponent, RecordResolver } from '../record';
import { DossierModelResolver } from '../dossier-model';

import { OperationListComponent, OperationEditComponent, OperationResolver } from '../operation';
import { RevisionListComponent, RevisionsResolver, RevisionResolver } from '../revision';
import { DocumentListComponent, DocumentEditComponent, DocumentsResolver, DocumentResolver } from '../document';

import { OrganigrammeComponent, OrganigrammeEntityResolver } from '../organigramme';

import { ExecutionForDossierComponent, ExecutionForOperationComponent, ExecutionEditComponent, ExecutionResolver } from '../execution';

import { SettingsComponent, CanAccessSettingsGuard } from '../settings';
import { UserListComponent, UserEditComponent } from '../user';
import { ReportComponent } from '../report';
import { CapitalisationComponent } from '../capitalisation';
import { ArchivedDossierListComponent } from '../dossier/archived-dossier-list.component';
import { ArchivedDossierDetailsComponent } from '../dossier/archived-dossier-details.component copy';
import { SLHomeComponent } from '../shares-ledger';
import { SLEntityListComponent, SLEntityEditComponent, SLEntityResolver, SLMovementEditComponent, SLMovementRegisterComponent, SLEntityVersionListComponent, SLEntityVersionResolver, SLEntityVersionEditComponent, SLEntityVersionVerifyComponent } from '../shares-ledger/entity';
import { CLAccountListComponent, CLAccountEditComponent, CLAccountResolver, CLAccountDeletedComponent } from '../shares-ledger/client';
import { CLUserListComponent, CLUserEditComponent, CLUserResolver, CLUserDeletedComponent } from '../shares-ledger/client';
import { DossierImportComponent } from '../dossier/dossier-import.component';
import { DLHomeComponent } from '../documents-ledger';
import { DLRootCertificateEditComponent, DLRootCertificateListComponent, DLRootCertificateResolver } from '../documents-ledger/root-certificate';
import { DLCompanyEditComponent, DLCompanyListComponent, DLCompanyResolver, DLDocumentEditComponent, DLLedgerEditComponent, DLLedgerResolver } from '../documents-ledger/company';
import { DLSettingsComponent } from '../documents-ledger/settings/settings.component';
import { INPIHomeComponent } from '../inpi';

const routes: Routes = [
  // Dossiers
  {
    path: 'dossiers',
    component: OutletComponent,
    data: {
      title: 'Dossiers',
    },
    children: [
      {
        path: '',
        component: DossierListComponent,
        data: {
          title: 'Dossiers'
        }
      },
      {
        path: 'new',
        component: DossierEditComponent,
        data: {
          title: 'Nouveau dossier',
          mode: 'new'
        },
        resolve: {
          dossierModel: DossierModelResolver
        }
      },
      {
        path: 'import',
        component: DossierImportComponent,
        data: {
          title: 'Importer une entité',
        },
      },
      {
        path: 'archive',
        component: OutletComponent,
        data: {
          title: 'Archive'
        },
        children: [
          {
            path: '',
            component: ArchivedDossierListComponent,
          },
          {
            path: ':dossier_id',
            component: ArchivedDossierDetailsComponent,
            resolve: {
              dossier: DossierResolver,
              dossierModel: DossierModelResolver
            }
          }
        ],
      },
      {
        path: ':dossier_id',
        component: OutletComponent,
        data: {
          title: 'DOSSIER_NAME',
          mode: 'edit'
        },
        children: [
          {
            path: 'execute',
            component: OutletComponent,
            data: {
              title: 'Exécuter une opération'
            },
            children: [
              {
                path: ':execution_id',
                component: ExecutionEditComponent,
                data: {
                  title: 'Modifier l\'exécution'
                },
                resolve: {
                  execution: ExecutionResolver
                }
              },
              {
                path: '',
                component: ExecutionForDossierComponent,
                data: {
                  title: 'Exécuter une opération'
                },
                resolve: {
                  dossier: DossierResolver,
                  dossierModel: DossierModelResolver
                }
              }
            ]
          },
          {
            path: 'organigramme',
            component: OrganigrammeComponent,
            data: {
              title: 'Organigramme',
              mode: 'dossier'
            },
            resolve: {
              entity: OrganigrammeEntityResolver
            }
          },
          {
            path: 'report',
            component: ReportComponent,
            data: {
              title: 'Rapport'
            },
            resolve: {
              dossier: DossierResolver,
              dossierModel: DossierModelResolver
            }
          },
          {
            path: 'capitalisation',
            component: CapitalisationComponent,
            data: {
              title: 'Importer la table de capitalisation'
            },
            resolve: {
              dossier: DossierResolver,
              dossierModel: DossierModelResolver
            }
          },
          {
            path: '',
            component: DossierEditComponent,
            data: {
              title: 'Modifier le dossier',
              mode: 'edit'
            },
            resolve: {
              dossier: DossierResolver,
              dossierModel: DossierModelResolver
            }
          }
        ]
      },
    ]
  },


  // Records
  {
    path: 'records',
    component: OutletComponent,
    data: {
      title: 'Enregistrements',
    },
    children: [
      {
        path: '',
        component: RecordListComponent,
        data: {
          title: 'Enregistrements'
        }
      },
      {
        path: ':record_id',
        component: OutletComponent,
        data: {
          title: 'RECORD_NAME',
          mode: 'view'
        },
        children: [
          {
            path: 'organigramme',
            component: OrganigrammeComponent,
            data: {
              title: 'Organigramme',
              mode: 'record'
            },
            resolve: {
              entity: OrganigrammeEntityResolver
            }
          },
          {
            path: '',
            component: RecordEditComponent,
            data: {
              title: 'Enregistrement',
              mode: 'view'
            },
            resolve: {
              record: RecordResolver,
              dossierModel: DossierModelResolver
            }
          }
        ]
      },
    ]
  },


  // Operations
  {
    path: 'operations',
    component: OutletComponent,
    data: {
      title: 'Opérations',
    },
    children: [
      {
        path: '',
        component: OperationListComponent,
        data: {
          title: 'Opérations'
        }
      },
      {
        path: 'new',
        component: OperationEditComponent,
        data: {
          title: 'Nouvelle opération',
          mode: 'new'
        },
      },
      {
        path: ':operation_id/edit',
        component: OperationEditComponent,
        data: {
          title: 'Modifier l\'opération',
          mode: 'edit'
        },
        resolve: {
          operation: OperationResolver,
        },
      },
      {
        path: ':operation_id',
        component: OutletComponent,
        data: {
          title: 'OPERATION_NAME'
        },
        children: [
          {
            path: ':revision_id',
            component: OutletComponent,
            data: {
              title: 'REVISION_NAME'
            },
            children: [
              {
                path: 'execute',
                component: OutletComponent,
                data: {
                  title: 'Exécuter une opération'
                },
                children: [
                  {
                    path: ':execution_id',
                    component: ExecutionEditComponent,
                    data: {
                      title: 'Modifier l\'exécution'
                    },
                    resolve: {
                      execution: ExecutionResolver
                    }
                  },
                  {
                    path: '',
                    component: ExecutionForOperationComponent,
                    data: {
                      title: 'Exécuter une opération'
                    },
                    resolve: {
                      operation: RevisionResolver,
                      dossierModel: DossierModelResolver
                    }
                  }
                ]
              },
              {
                path: 'new',
                component: DocumentEditComponent,
                data: {
                  title: 'Nouveau document',
                  mode: 'new'
                },
                resolve: {
                  operation: RevisionResolver,
                  dossierModel: DossierModelResolver
                },
              },
              {
                path: ':document_id/edit',
                component: DocumentEditComponent,
                data: {
                  title: 'Modifier le document',
                  mode: 'edit'
                },
                resolve: {
                  operation: DocumentResolver,
                  dossierModel: DossierModelResolver
                },
              },
              {
                path: ':document_id',
                component: DocumentEditComponent,
                data: {
                  mode: 'view'
                },
                resolve: {
                  operation: DocumentResolver,
                  dossierModel: DossierModelResolver
                },
              },
              {
                path: '',
                component: DocumentListComponent,
                resolve: {
                  operation: DocumentsResolver,
                  dossierModel: DossierModelResolver
                },
              }
            ]
          },
          {
            path: '',
            component: RevisionListComponent,
            data: {

            },
            resolve: {
              operation: RevisionsResolver
            },
          }
        ]
      }
    ]
  },

  // Shares register
  {
    path: 'shares-ledger',
    component: OutletComponent,
    data: {
      title: 'Registre des actions'
    },
    children: [
      {
        path: '',
        component: SLHomeComponent,
        data: {
          title: 'Registre des actions'
        }
      },
      // Verify
      {
        path: 'verify',
        component: SLEntityVersionVerifyComponent,
      },
      // Entity
      {
        path: 'entities',
        component: OutletComponent,
        data: {
          title: 'Entités',
        },
        children: [
          {
            path: '',
            component: SLEntityListComponent,
            data: {
              title: 'Entités'
            }
          },
          {
            path: 'new',
            component: SLEntityEditComponent,
            data: {
              title: 'Nouvelle entité',
              mode: 'new'
            },
            resolve: {
              dossierModel: DossierModelResolver,
            },
          },
          {
            path: ':entity_id',
            component: OutletComponent,
            data: {
              title: 'SL_ENTITY_NAME',
              mode: 'view'
            },
            children: [
              {
                path: 'movements-ledger/:entity_version',
                component: SLMovementRegisterComponent,
                data: {
                  title: 'Registre des mouvements de titres',
                },
                resolve: {
                  entity: SLEntityVersionResolver,
                }
              },
              {
                path: 'movements/new',
                component: SLMovementEditComponent,
                data: {
                  title: 'Nouveau mouvement',
                  mode: 'new',
                  cancelLink: '../..',
                },
                resolve: {
                  entity: SLEntityResolver,
                  dossierModel: DossierModelResolver,
                }
              },
              {
                path: 'movements/:movement_id',
                component: SLMovementEditComponent,
                data: {
                  title: 'Movement',
                  mode: 'view',
                  cancelLink: '../..',
                },
                resolve: {
                  entity: SLEntityResolver,
                }
              },
              {
                path: 'deleted-movements/:movement_id',
                component: SLMovementEditComponent,
                data: {
                  title: 'Movement',
                  mode: 'view',
                  subMode: 'deleted',
                  cancelLink: '../..',
                },
                resolve: {
                  entity: SLEntityResolver,
                }
              },
              {
                path: 'draft-movements/:movement_id',
                component: SLMovementEditComponent,
                data: {
                  title: 'Movement',
                  mode: 'view',
                  subMode: 'draft',
                  cancelLink: '../..',
                },
                resolve: {
                  entity: SLEntityResolver,
                }
              },
              {
                path: 'edit',
                component: SLEntityEditComponent,
                data: {
                  title: 'Modifier l\'entité',
                  mode: 'edit'
                },
                resolve: {
                  entity: SLEntityResolver,
                  dossierModel: DossierModelResolver,
                }
              },
              {
                path: 'history',
                component: OutletComponent,
                data: {
                  title: 'Historique'
                },
                children: [
                  {
                    path: ':entity_version/movements-ledger',
                    component: SLMovementRegisterComponent,
                    data: {
                      title: 'Registre des mouvements de titres',
                    },
                    resolve: {
                      entity: SLEntityVersionResolver,
                    }
                  },
                  {
                    path: ':entity_version/movements/:movement_id',
                    component: SLMovementEditComponent,
                    data: {
                      title: 'Movement',
                      mode: 'view',
                      cancelLink: '../..',
                    },
                    resolve: {
                      entity: SLEntityVersionResolver,
                    }
                  },
                  {
                    path: ':entity_version',
                    component: SLEntityVersionEditComponent,
                    data: {
                      title: 'Historique',
                    },
                    resolve: {
                      entity: SLEntityVersionResolver,
                    }
                  },
                  {
                    path: '',
                    component: SLEntityVersionListComponent,
                    data: {
                      title: 'Historique',
                    },
                    resolve: {
                      entity: SLEntityResolver,
                    }
                  },
                ],
              },
              {
                path: '',
                component: SLEntityEditComponent,
                data: {
                  title: 'Entité',
                  mode: 'view'
                },
                resolve: {
                  entity: SLEntityResolver,
                  dossierModel: DossierModelResolver,
                }
              }
            ]
          },
        ]
      },
      // Client account
      {
        path: 'client-accounts',
        component: OutletComponent,
        data: {
          title: 'Comptes clients',
        },
        children: [
          {
            path: '',
            component: CLAccountListComponent,
            data: {
              title: 'Comptes clients'
            }
          },
          {
            path: 'deleted',
            component: OutletComponent,
            data: {
              title: 'Supprimés'
            },
            children: [
              {
                path: ':client_account_id',
                component: CLAccountEditComponent,
                data: {
                  title: 'Compte client',
                  mode: 'view'
                },
                resolve: {
                  account: CLAccountResolver,
                }
              },
              {
                path: '',
                component: CLAccountDeletedComponent,
                data: {
                  title: 'Supprimés',
                  mode: 'view'
                },
              }
            ]
          },
          {
            path: 'new',
            component: CLAccountEditComponent,
            data: {
              title: 'Nouveau compte client',
              mode: 'new'
            },
          },
          {
            path: ':client_account_id',
            component: OutletComponent,
            data: {
              title: 'CL_ACCOUNT_NAME',
              mode: 'view'
            },
            children: [
              {
                path: 'edit',
                component: CLAccountEditComponent,
                data: {
                  title: 'Modifier le compte client',
                  mode: 'edit'
                },
                resolve: {
                  account: CLAccountResolver,
                }
              },
              {
                path: '',
                component: CLAccountEditComponent,
                data: {
                  title: 'Compte client',
                  mode: 'view'
                },
                resolve: {
                  account: CLAccountResolver,
                }
              }
            ]
          },
        ]
      },
      // Client user
      {
        path: 'client-users',
        component: OutletComponent,
        data: {
          title: 'Utilisateurs clients',
        },
        children: [
          {
            path: '',
            component: CLUserListComponent,
            data: {
              title: 'Utilisateurs clients'
            }
          },
          {
            path: 'deleted',
            component: OutletComponent,
            data: {
              title: 'Supprimés'
            },
            children: [
              {
                path: ':client_user_id',
                component: CLUserEditComponent,
                data: {
                  title: 'Utilisateur client',
                  mode: 'view'
                },
                resolve: {
                  user: CLUserResolver,
                }
              },
              {
                path: '',
                component: CLUserDeletedComponent,
                data: {
                  title: 'Supprimés',
                  mode: 'view'
                },
              }
            ]
          },
          {
            path: 'new',
            component: CLUserEditComponent,
            data: {
              title: 'Nouvel utilisateur client',
              mode: 'new'
            },
          },
          {
            path: ':client_user_id',
            component: OutletComponent,
            data: {
              title: 'CL_USER_NAME',
              mode: 'view'
            },
            children: [
              {
                path: 'edit',
                component: CLUserEditComponent,
                data: {
                  title: 'Modifier l\'utilisateur client',
                  mode: 'edit'
                },
                resolve: {
                  user: CLUserResolver,
                }
              },
              {
                path: '',
                component: CLUserEditComponent,
                data: {
                  title: 'Utilisateur client',
                  mode: 'view'
                },
                resolve: {
                  user: CLUserResolver,
                }
              }
            ]
          },
        ]
      },
    ]
  },

  // Documents ledger
  {
    path: 'documents-ledger',
    component: OutletComponent,
    data: {
      title: 'Registres'
    },
    children: [
      {
        path: '',
        component: DLHomeComponent,
        data: {
          title: 'Registres'
        }
      },
      // Root certificate
      {
        path: 'root-certificates',
        component: OutletComponent,
        data: {
          title: 'Certificats racine',
        },
        children: [
          {
            path: '',
            component: DLRootCertificateListComponent,
            data: {
              title: 'Certificats racine'
            }
          },
          {
            path: 'new',
            component: DLRootCertificateEditComponent,
            data: {
              title: 'Nouveau certificat racine',
              mode: 'new'
            },
          },
          {
            path: ':root_certificate_id',
            component: OutletComponent,
            data: {
              title: 'DL_ROOT_CERTIFICATE_NAME',
              mode: 'view'
            },
            children: [
              {
                path: 'edit',
                component: DLRootCertificateEditComponent,
                data: {
                  title: 'Modifier le certificat racine',
                  mode: 'edit'
                },
                resolve: {
                  rootCertificate: DLRootCertificateResolver,
                }
              },
              {
                path: '',
                component: DLRootCertificateEditComponent,
                data: {
                  title: 'Certificat racine',
                  mode: 'view'
                },
                resolve: {
                  rootCertificate: DLRootCertificateResolver,
                }
              }
            ]
          },
        ]
      },

      // Sociétés
      {
        path: 'companies',
        component: OutletComponent,
        data: {
          title: 'Sociétés',
        },
        children: [
          {
            path: '',
            component: DLCompanyListComponent,
            data: {
              title: 'Sociétés'
            }
          },
          {
            path: 'new',
            component: DLCompanyEditComponent,
            data: {
              title: 'Nouvelle société',
              mode: 'new'
            },
          },
          {
            path: ':company_id',
            component: OutletComponent,
            data: {
              title: 'DL_COMPANY_NAME',
              mode: 'view'
            },
            children: [
              {
                path: 'edit',
                component: DLCompanyEditComponent,
                data: {
                  title: 'Modifier la société',
                  mode: 'edit'
                },
                resolve: {
                  company: DLCompanyResolver,
                }
              },
              {
                path: '',
                component: DLCompanyEditComponent,
                data: {
                  title: 'Société',
                  mode: 'view'
                },
                resolve: {
                  company: DLCompanyResolver,
                }
              },
              {
                path: 'new',
                component: DLLedgerEditComponent,
                data: {
                  title: 'Nouveau registre',
                  mode: 'new'
                },
                resolve: {
                  company: DLCompanyResolver,
                }
              },
              {
                path: ':ledger_id',
                component: OutletComponent,
                data: {
                  title: 'DL_LEDGER_NAME',
                  mode: 'view'
                },
                children: [
                  {
                    path: 'edit-documents',
                    component: DLDocumentEditComponent,
                    data: {
                      title: 'Modifier la liste des documents',
                      mode: 'edit'
                    },
                    resolve: {
                      company: DLLedgerResolver,
                    }
                  },
                  {
                    path: 'edit',
                    component: DLLedgerEditComponent,
                    data: {
                      title: 'Modifier le registre',
                      mode: 'edit'
                    },
                    resolve: {
                      company: DLLedgerResolver,
                    }
                  },
                  {
                    path: '',
                    component: DLLedgerEditComponent,
                    data: {
                      title: 'Registre',
                      mode: 'view'
                    },
                    resolve: {
                      company: DLLedgerResolver,
                    }
                  }
                ]
              },
            ]
          },
        ]
      },

      // Settings
      {
        path: 'settings',
        component: DLSettingsComponent,
        data: {
          title: 'Paramètres'
        }
      },
    ]
  },

  // INPI
  {
    path: 'inpi',
    component: OutletComponent,
    data: {
      title: 'Données INPI'
    },
    children: [
      {
        path: '',
        component: INPIHomeComponent,
        data: {
          title: 'Données INPI'
        }
      },
    ]
  },

  // Settings
  {
    path: 'settings',
    component: OutletComponent,
    data: {
      title: 'Paramètres'
    },
    canActivate: [CanAccessSettingsGuard],
    canActivateChild: [CanAccessSettingsGuard],
    children: [
      {
        path: '',
        component: SettingsComponent,
        data: {
          title: 'Paramètres'
        }
      },
      {
        path: 'users',
        component: OutletComponent,
        data: {
          title: 'Utilisateurs'
        },
        children: [
          {
            path: '',
            component: UserListComponent,
            data: {
              title: 'Utilisateurs'
            },
          },
          {
            path: 'new',
            component: UserEditComponent,
            data: {
              title: 'Nouvel utilisateur',
              mode: 'new'
            },
          },
          {
            path: ':id',
            component: UserEditComponent,
            data: {
              title: 'Modifier l\'utilisateur',
              mode: 'edit'
            },
          },
        ]
      },
    ]
  },

  // Profile
  {
    path: 'profile',
    component: UserEditComponent,
    data: {
      title: 'Mon profile',
      mode: 'profile'
    },
  },


  // General routes
  {
    path: '',
    redirectTo: '/dossiers',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/dossiers',
    pathMatch: 'full'
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
